import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { WeightUnitConverter } from "@/Common/Utilities/Units/WeightUnitConverter";

class OntarioObstetricalFileFormCommonData {
    public FinalEstimatedDateOfBirth: Date | null;
    public PlannedPlaceOfBirth: string;
    public PlannedBirthAttendant: string;
    public NewbornCareProviderInHospital: string;
    public NewbornCareProviderInCommunity: string;
    public AllergiesOrSensitivities: string;
    public Medications: string;
    public FamilyPhysicianPrimaryCareProvider: string;
    public PrePregnancyWeight?: number;
    public PrePregnancyWeightUnit: WeightUnit;
    public PrePregnancyBodyMassIndex?: number;

    public get ConvertedPrePregnancyWeight(): number {
        return WeightUnitConverter.convert(WeightUnit.Kilogram, this.PrePregnancyWeightUnit, this.PrePregnancyWeight, 2);
    }

    public set ConvertedPrePregnancyWeight(value: number) {
        this.PrePregnancyWeight = WeightUnitConverter.convert(this.PrePregnancyWeightUnit, WeightUnit.Kilogram, value);
    }

    public constructor(fields?: Partial<OntarioObstetricalFileFormCommonData>) {
        this.PrePregnancyWeightUnit = sessionStore.useMetricSystemAsDefault ? WeightUnit.Kilogram : WeightUnit.Pound;
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalFileFormCommonData };
